var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, CircularProgress, Link, Typography } from '@mui/material';
import { useAnalytics } from 'hx-analytics';
import { imageGuyWithGlasses } from 'hx-assets';
import { NavButtons } from 'hx-navigator';
import { videoCallService } from 'hx-twilio-video';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useSalesforceService } from '@/hooks/use-salesforce-service.hook';
import { BusinessHours } from '@/components/business-hours.component';
import { StepLayout } from '@/components/step-layout.component';
import { NavigationButton } from '@/components/navigation-button.component';
var getIsInBusinessHours = videoCallService.getIsInBusinessHours;
export var SelectionPage = function () {
    var navigate = useNavigate();
    var _a = useQuery({
        queryKey: ['isInBusinessHours'],
        queryFn: function () { return getIsInBusinessHours(); },
        staleTime: 1000 * 60,
    }), data = _a.data, businessHoursError = _a.error;
    var isInBusinessHours = data === null || data === void 0 ? void 0 : data.is_open;
    var businessHours = data === null || data === void 0 ? void 0 : data.operating_schedule.regularHours;
    var _b = useSalesforceService(), isLoading = _b.isLoading, isSuccess = _b.isSuccess, salesforceError = _b.error, sendVideoCallCompleted = _b.sendVideoCallCompleted, sendCallbackRequested = _b.sendCallbackRequested;
    var handleSpeakToAnExpertNowClick = function () {
        sendVideoCallCompleted();
        navigate('/video-call');
    };
    var handleRequestACallBackClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, sendCallbackRequested()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var sendButtonClick = useAnalytics().sendButtonClick;
    var handleEndSessionClick = function () {
        navigate('/');
        sendButtonClick('session-end');
    };
    return (_jsx(StepLayout, { image: imageGuyWithGlasses, heading: "Thank you for selecting to speak to one of our product experts.", content: _jsxs("div", __assign({ className: "self-start max-w-sm text-center " }, { children: [!businessHours || businessHoursError ? (_jsx(Alert, __assign({ severity: "error", className: "max-w-[50ch] self-start" }, { children: "Error retrieving business hours." }))) : !isInBusinessHours ? (_jsx(BusinessHours, { businessHours: businessHours })) : (_jsx(Typography, __assign({ variant: "body1" }, { children: "Would you like to:" }))), isSuccess && (_jsx(Alert, __assign({ severity: "info", className: "max-w-[50ch] self-start mt-4" }, { children: "A product expert will be in touch shortly." }))), salesforceError && (_jsx(Alert, __assign({ severity: "error", className: "max-w-[50ch] self-start mt-4" }, { children: "An Error occurred while sending your request, please try again." })))] })), nav: _jsxs(NavButtons, __assign({ col: true }, { children: [!isSuccess && (_jsxs(_Fragment, { children: [_jsx(NavigationButton, __assign({ variant: "contained", onClick: handleSpeakToAnExpertNowClick, disabled: !isInBusinessHours, useDefaultClasses: false }, { children: "Speak to an expert now" })), _jsx(NavigationButton, __assign({ variant: "outlined", onClick: handleRequestACallBackClick, useDefaultClasses: false }, { children: isLoading ? (_jsx(CircularProgress, { color: "inherit", size: "1.5rem" })) : ('Request a call back') }))] })), _jsx(Link, __assign({ component: "button", variant: "link", onClick: handleEndSessionClick }, { children: "End session" }))] })) }));
};
